// useSubscription.ts
import { useSelector } from 'react-redux';

interface Subscription {
  leftDays: number;
  isActive: boolean;
  id: string;
  status: string;
  package: string;
  freeTrialDays: number;
}

export const useSubscription = () => {
  // ✅ If you keep subscription in Redux:
  const subscription: Subscription | null =
    useSelector((state: any) => state.login?.userData?.subscription) || null;

  // ✅ Or fallback to localStorage (optional)
  const localSubscription = subscription
    ? subscription
    : JSON.parse(localStorage.getItem('user') ?? 'null')?.subscription ?? null;

  const isActive = localSubscription?.isActive ?? false;
  const leftDays = localSubscription?.leftDays ?? 0;
  const freeTrialDays = localSubscription?.freeTrialDays ?? 0;
  const packageSubscribed = localSubscription?.package;
  const packageItems = packageSubscribed?.items;

  const hasValidSubscription = freeTrialDays > 0 || leftDays > 0;
  const canUseChat = packageItems?.chat;
  const canAddYouTubeLink =  packageItems?.youtubeVideo;
  const propertyListingCount = packageItems?.propertyListing;
  const featureProperty = packageItems?.featureProperty;
  const canSeeHousingRequest = packageItems?.housingRequest;
  const photosCount = packageItems?.photos;


  return { subscription: localSubscription, isActive, leftDays, freeTrialDays, packageSubscribed, canUseChat,
    canAddYouTubeLink, propertyListingCount, featureProperty, hasValidSubscription, canSeeHousingRequest,
    packageItems, photosCount
   };
};
